export const toOneDecimalPlace = (numberToTrunc: number) => parseFloat(numberToTrunc.toFixed(1));
